import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { SharedService } from '../../../../Services/shared.service';
import { SectionFreeMockComponent } from './section-free-mock/section-free-mock.component';
import { SectionProgressReportComponent } from './section-progress-report/section-progress-report.component';
import { SectionStudyMaterialsComponent } from './section-study-materials/section-study-materials.component';
import { Dialog } from '@angular/cdk/dialog';
import { DialogMychildComponent } from '../../../Home/Components/dialog-mychild/dialog-mychild.component';
@Component({
  selector: 'app-dashboard',
  imports: [FormsModule, RouterModule, CommonModule, SectionFreeMockComponent, SectionProgressReportComponent, SectionStudyMaterialsComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent {



  PREP_UserInfo: any = 0;

  constructor(public _svc: SharedService, private _router: Router, private _dialog: Dialog) {

  }

  ngOnInit(): void {


  }


}